"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.entryDef = exports.markStateDef = exports.stateDef = exports.learnerDef = exports.entryBatchDataDef = exports.entryIdentifierDef = exports.MarksSubmissionStatus = exports.WithdrawalOrigin = void 0;
const joi_1 = __importDefault(require("joi"));
const general_1 = require("../general");
const schemaValidator_1 = require("../../util/schemaValidator");
const BusinessUnit_1 = require("../internal/BusinessUnit");
const __1 = require("..");
var WithdrawalOrigin;
(function (WithdrawalOrigin) {
    WithdrawalOrigin["SYNCHRONIZATION"] = "eps-synchronization";
    WithdrawalOrigin["SUBMITTER"] = "sapi-ee-submitter";
})(WithdrawalOrigin = exports.WithdrawalOrigin || (exports.WithdrawalOrigin = {}));
var MarksSubmissionStatus;
(function (MarksSubmissionStatus) {
    MarksSubmissionStatus["MARKS_SENT"] = "MARKS_SENT";
    MarksSubmissionStatus["MARKS_PENDING"] = "MARKS_PENDING";
    MarksSubmissionStatus["MARKS_ERROR"] = "MARKS_ERROR";
    MarksSubmissionStatus["MARKS_RETRY"] = "MARKS_RETRY";
    MarksSubmissionStatus["MARKS_SENT_WITH_ERRORS"] = "MARKS_SENT_WITH_ERRORS";
})(MarksSubmissionStatus = exports.MarksSubmissionStatus || (exports.MarksSubmissionStatus = {}));
exports.entryIdentifierDef = {
    learnerNumber: joi_1.default.number(),
    learnerUniqueId: joi_1.default.string(),
};
exports.entryBatchDataDef = {
    sessionId: joi_1.default.number().required(),
    centreId: joi_1.default.string().required(),
    candidateNumber: joi_1.default.number().required(),
    assessmentCode: joi_1.default.string().required(),
    componentId: joi_1.default.string().required(),
    missingAbsentInd: joi_1.default.string().allow(null),
    mark: joi_1.default.number(),
};
exports.learnerDef = {
    name: joi_1.default.string().required(),
    number: joi_1.default.number().optional(),
    uniqueId: joi_1.default.string().required(),
};
exports.stateDef = {
    submitted: joi_1.default.boolean().default(false),
    withdrawalDate: joi_1.default.string(),
    withdrawalOrigin: joi_1.default.string().optional(),
    submissionDate: joi_1.default.string().allow(null),
    submitter: (0, schemaValidator_1.objectSchema)(__1.UserInfoSchema),
    isResubmissionRequired: joi_1.default.boolean(),
};
exports.markStateDef = {
    submitted: joi_1.default.boolean().default(false),
    approved: joi_1.default.boolean().optional(),
    isEpsOrigin: joi_1.default.boolean().default(false),
    submitter: (0, schemaValidator_1.objectSchema)(__1.UserInfoSchema),
    submissionDate: joi_1.default.string().allow(null),
    markHidden: joi_1.default.boolean().optional(),
    examinerNumber: joi_1.default.string().allow(null),
};
exports.entryDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(), seriesId: joi_1.default.number().required(), centreId: joi_1.default.string().required(), qualificationId: joi_1.default.number().required(), assessmentCode: joi_1.default.string().required(), assessmentVersion: joi_1.default.number().optional(), componentNumber: joi_1.default.string().required(), componentType: __1.componentTypeSchemaField.optional(), learner: (0, schemaValidator_1.objectSchema)(exports.learnerDef), state: (0, schemaValidator_1.objectSchema)(exports.stateDef), mark: joi_1.default.number().allow(null), absent: joi_1.default.boolean().allow(null).optional(), markState: (0, schemaValidator_1.objectSchema)(exports.markStateDef), outcomeType: joi_1.default.string(), outcomeStatus: joi_1.default.string(), marksSubmissionError: joi_1.default.string(), specialConsideration: joi_1.default.object({
        enabled: joi_1.default.boolean().required(),
        isEpsOrigin: joi_1.default.boolean().required(),
    }).optional() });
